import React from "react";
import PrintersPage from "./PrintersPage";
import usePrinters from "./usePrinters";

function Printers() {
  return <PrintersPage {...usePrinters()} />;
}

export default Printers;
